import Header from "./features/header";
new Header();
import NavMobile from "./features/nav-mobile";
new NavMobile();

// import RdStacked from "./components/rd-stacked";
import RdVideo from "./components/rd-video";
// import RdCarousel from "./components/rd-carousel";

document.documentElement.classList.replace('no-js', 'js');
